import * as React from "react";
import { Fingerprint } from "lucide-react";

export const VerifyingPasskey: React.FC = () => {
  return (
    <div className="py-12 flex flex-col items-center justify-center space-y-6 animate-in fade-in duration-200">
      <div className="relative">
        <div className="h-20 w-20 rounded-full border-4 border-slate-100 border-t-indigo-500 animate-spin" />
        <Fingerprint className="h-8 w-8 text-indigo-500 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
      </div>
      <div className="text-center">
        <h3 className="text-lg font-semibold text-slate-800">Verifying Passkey</h3>
        <p className="text-sm text-slate-500 mt-1">Please use your device's biometric or screen lock</p>
      </div>
    </div>
  );
};
